/** Maps Completion domain values to the Supabase `completions` table. */
import type { Completion } from '@life-rpg/shared';
import type { SupabaseClient } from '@supabase/supabase-js';

import type { CompletionInsert, CompletionRow, Database } from '../../database.types.js';
import type { CompletionRemote } from '../completionLog.js';

const COLUMNS = 'id, activity_id, at, qty, energy, day_at_write' as const;

const fromRow = (row: CompletionRow): Completion => ({
  id: row.id,
  activityId: row.activity_id,
  at: row.at,
  qty: row.qty,
  energy: row.energy,
  dayAtWrite: row.day_at_write,
});

const toRow = (completion: Completion): CompletionInsert => ({
  id: completion.id,
  activity_id: completion.activityId,
  at: completion.at,
  qty: completion.qty,
  energy: completion.energy,
  day_at_write: completion.dayAtWrite,
});

export const createSupabaseCompletionRemote = (
  client: SupabaseClient<Database>,
): CompletionRemote => ({
  list: async () => {
    const { data, error } = await client
      .from('completions')
      .select(COLUMNS)
      .order('at', { ascending: true });
    if (error) throw error;
    return data.map(fromRow);
  },

  save: async (completion) => {
    const { error } = await client
      .from('completions')
      .upsert(toRow(completion), { onConflict: 'id', ignoreDuplicates: true });
    if (error) throw error;
  },
});
